import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Shirt } from 'lucide-react';

export default function ArtikelEidKleidungKinder() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Eid Kleidung für Kinder: Tradition & moderne Looks</h1>
          <p className="text-lg text-white/80 leading-relaxed">Von traditioneller Festkleidung bis zu modernen Outfits – so kleiden sich Kinder zu Eid.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Neue Kleidung zu Eid ist eine wunderschöne Tradition. Kinder freuen sich das ganze Jahr auf ihr Eid-Outfit! Hier findest du Inspiration für traditionelle und moderne Looks – für Jungen und Mädchen jeden Alters.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Shirt className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Für Mädchen</h2>
            </div>
            
            <h3 className="font-serif text-xl font-medium text-[#2C332E] mb-4">Traditionelle Looks</h3>
            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Festliches Abaya-Kleid</h4>
                <p className="text-sm text-[#4B5563]">Kindgerechte Abaya in Pastellfarben mit Stickerei oder Pailletten. Elegant und bequem zugleich.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Traditionelles Kaftan-Kleid</h4>
                <p className="text-sm text-[#4B5563]">Locker fließend mit orientalischen Mustern. Perfekt für den Eid-Tag und Familienfotos.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Shalwar Kameez</h4>
                <p className="text-sm text-[#4B5563]">Traditionelle südasiatische Festkleidung – bunt, bestickt und festlich.</p>
              </div>
            </div>

            <h3 className="font-serif text-xl font-medium text-[#2C332E] mb-4">Moderne Looks</h3>
            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Festliches Kleid mit Hijab</h4>
                <p className="text-sm text-[#4B5563]">Elegantes Kleid kombiniert mit passendem Kinder-Hijab. Modern und bescheiden.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Rock & Bluse Kombination</h4>
                <p className="text-sm text-[#4B5563]">Tüllrock mit schöner Bluse – festlich und kindgerecht.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Jumpsuit mit Verzierung</h4>
                <p className="text-sm text-[#4B5563]">Modisch und praktisch – perfekt für aktive Kinder, die auch spielen wollen!</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center"><Shirt className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Für Jungen</h2>
            </div>
            
            <h3 className="font-serif text-xl font-medium text-[#2C332E] mb-4">Traditionelle Looks</h3>
            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Thobe/Jubba</h4>
                <p className="text-sm text-[#4B5563]">Klassisches arabisches Gewand in Weiß oder Pastelltönen. Elegant zum Eid-Gebet.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Kurta Pyjama</h4>
                <p className="text-sm text-[#4B5563]">Traditionelle südasiatische Kleidung – bequem und festlich zugleich.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Moroccan Kaftan für Jungen</h4>
                <p className="text-sm text-[#4B5563]">Verzierter Kaftan mit Stickerei – königlich und festlich.</p>
              </div>
            </div>

            <h3 className="font-serif text-xl font-medium text-[#2C332E] mb-4">Moderne Looks</h3>
            <div className="space-y-4 mb-6">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Hemd & Stoffhose</h4>
                <p className="text-sm text-[#4B5563]">Klassisch elegant – weißes Hemd mit Fliege oder Krawatte.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Anzug oder Blazer</h4>
                <p className="text-sm text-[#4B5563]">Mini-Gentleman-Look – besonders schön für Familienfotos.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Polo & Chino</h4>
                <p className="text-sm text-[#4B5563]">Smart Casual – gepflegt aber bequem für den aktiven Eid-Tag.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Accessoires für Kinder</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für Mädchen</h4>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>• Kinder-Hijab (passend zum Kleid)</li>
                  <li>• Haarschmuck & Haarreifen</li>
                  <li>• Kinderschmuck (Armband, Kette)</li>
                  <li>• Festliche Tasche</li>
                  <li>• Lackschuhe oder Ballerinas</li>
                </ul>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für Jungen</h4>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>• Kufi/Taqiyah (Gebetsmütze)</li>
                  <li>• Fliege oder Krawatte</li>
                  <li>• Festliche Uhr</li>
                  <li>• Ledergürtel</li>
                  <li>• Elegante Schuhe</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Tipps für den Eid-Outfit-Kauf</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Früh kaufen:</strong> Beliebte Größen sind vor Eid schnell vergriffen</li>
                <li><strong>Bequemlichkeit:</strong> Kinder sollten spielen und sich bewegen können</li>
                <li><strong>Praktisch denken:</strong> Leicht waschbar und strapazierfähig</li>
                <li><strong>Kinder einbeziehen:</strong> Lass sie mitentscheiden – sie tragen es!</li>
                <li><strong>Fotos planen:</strong> Outfits der Familie aufeinander abstimmen</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Wo kaufen?</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Online-Shops</h4>
                <p className="text-sm text-[#4B5563]">Modanisa, Sefamerve, Amazon, Etsy – große Auswahl an islamischer Kindermode.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Lokale Geschäfte</h4>
                <p className="text-sm text-[#4B5563]">Islamische Boutiquen, orientalische Geschäfte, türkische/arabische Viertel.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Reguläre Kindermode</h4>
                <p className="text-sm text-[#4B5563]">H&M, Zara Kids, C&A – festliche Kleidung, die man islamisch stylen kann.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Neue Kleidung zu Eid ist eine Tradition, auf die sich Kinder das ganze Jahr freuen. Ob traditionell oder modern – das wichtigste ist, dass sich die Kinder wohlfühlen und den besonderen Tag genießen können.</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/25-geschenke-kinder" className="text-[#4A5D4F] hover:underline">→ 25 beste Eid Geschenke für Kinder</Link></li>
              <li><Link to="/ratgeber/eid-rezepte-kinder" className="text-[#4A5D4F] hover:underline">→ Kinderfreundliche Eid Rezepte</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Kinderprodukte entdecken</h3>
            <Link to="/geschenke/kinder" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
